import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { startWith, tap } from 'rxjs/operators';
import { RequestCache } from '../services/abstract/request-cache.service';

@Injectable()
export class CachingInterceptor implements HttpInterceptor {
	constructor(private cache: RequestCache) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// continue if not cachable.
		if (!this.isRequestCachable(req)) { return next.handle(req); }

		const cachedResponse = this.cache.get(req);
		// cache-then-refresh
		if (req.headers.get('x-refresh')) {
			const results$ = this.sendRequest(req, next, this.cache);
			return cachedResponse ?
				results$.pipe(startWith(cachedResponse)) :
				results$;
		}
		// cache-or-fetch
		return cachedResponse ?
			of(cachedResponse) : this.sendRequest(req, next, this.cache);
	}

	private isRequestCachable(req: HttpRequest<any>) {
		return (req.method === 'GET' && this.urlsNoCache(req.url));
	}

	private sendRequest(
		req: HttpRequest<any>,
		next: HttpHandler,
		cache: RequestCache): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			tap(event => {
				// There may be other events besides the response.
				if (event instanceof HttpResponse) {
					cache.put(req, event); // Update the cache.
				}
			})
		);
	}

	urlsNoCache(url: string) {
		return (url.indexOf('Rnt/ConsultaMisRnt?PageNumber') < 0) &&
			(url.indexOf('/opcionesporusuario') < 0) &&
			(url.indexOf('/TipoRnt') < 0) &&
			(url.indexOf('/AccionRnt') < 0) &&
			(url.indexOf('/ConfigurarEmailContacto') < 0) &&
			(url.indexOf('/TipoCapacidadTecnica') < 0) &&
			(url.indexOf('/CampoAdicional') < 0) &&
			(url.indexOf('/Faq') < 0) &&
			(url.indexOf('/OpcionModulo') < 0) &&
			(url.indexOf('/OpcionRol') < 0) &&
			(url.indexOf('/Documento') < 0) &&
			(url.indexOf('/ModuloEncuesta') < 0) &&
			(url.indexOf('/Modulo') < 0) &&
			(url.indexOf('/ModuloEncuestaSubCategoria') < 0) &&
			(url.indexOf('/OpcionRespuestaEncuesta') < 0) &&
			(url.indexOf('/OpcionRespuestaAdicionalEncuesta') < 0) &&
			(url.indexOf('/PasoSolicitud') < 0) &&
			(url.indexOf('/TipoTurismoAventura') < 0) &&
			(url.indexOf('/Categoria') < 0) &&
			(url.indexOf('/TipoDato') < 0) &&
			(url.indexOf('/PreguntaAdicionalEncuesta') < 0) &&
			(url.indexOf('/PreguntaEncuesta') < 0) &&
			(url.indexOf('/SeccionEncuesta') < 0) &&
			(url.indexOf('/SubCategoriasTopes') < 0) &&
			(url.indexOf('/SubCategoria') < 0) &&
			(url.indexOf('/TipoIdentificacion') < 0) &&
			(url.indexOf('/TipoPreguntaEncuesta') < 0) &&
			(url.indexOf('/Legislacion') < 0) &&
			(url.indexOf('/Rol') < 0) &&
			(url.indexOf('/Entorno') < 0) &&
			(url.indexOf('/TiposTerminosCondiciones') < 0) &&
			(url.indexOf('/FormacionEmpleado') < 0) &&
			(url.indexOf('/Usuario') < 0) &&
			(url.indexOf('/UsuarioRol') < 0) &&
			(url.indexOf('/RecursoAudiovisual') < 0) &&
			(url.indexOf('/MotivoDevolucion') < 0) &&
			(url.indexOf('/ContenidoCertificado') < 0) &&
			(url.indexOf('/DetalleCondiciones') < 0) &&
			(url.indexOf('/TipoConfiguracionInterfaz') < 0) &&
			(url.indexOf('/TerminosCondiciones') < 0) &&
			(url.indexOf('/tipo-establecimiento') < 0) &&
			(url.indexOf('/actividades-economicas-rnt') < 0) &&
			(url.indexOf('/perfil') < 0) &&
			(url.indexOf('/Sanciones') < 0) &&
			(url.indexOf('/SancionesPersona') < 0) &&
			(url.indexOf('/NotificacionesMasivasAdministrador/RedactarMensaje') < 0) &&
			(url.indexOf('/ConfiguracionInterfazInicial') < 0) &&
			(url.indexOf('/Notificaciones/GetCantidad') < 0) &&
			(url.indexOf('/DepositarioProvisionalAdministrador') < 0) &&
			(url.indexOf('/ConfiguracionDireccionEstandar') < 0);
		// (url.indexOf('/recuperarContrasena') > -1) ||
		// (url === '/');
	}

}
